import axios from "axios";

export class HttpError extends Error {
    constructor(message) {
        super(message);
        this.name = 'HttpError';
        object.setPrototypeOf(this, new.target.prototype);
    }
}

export function httpErrorHandler(error) {
    if (error === null) throw new Error('Unrecoverable error!! Error is null!')

    if (axios.isAxiosError(error)) {

        const response = error.response
        const request = error.request
        const config = error.config

        if (error.code === 'ERR_NETWORK') {
            console.error('connection problems..')
        } else if (error.code === 'ERR_CANCELED') {
            console.error('connection canceled..')
        }

        if (response) {

            const statusCode = response.status

            if (statusCode === 404) {
                console.error('The requested resource does not exist or has been deleted')

            } else if (statusCode === 401) {
                console.error('Please login to access this resource')
            }

        } else if (request) {
            //The request was made but no response was received, `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in Node.js
        }
    }

    console.error(error)
}
